import { Tag, Flex, Text } from "@chakra-ui/react";
import { Container } from "./styles";
import moment from "moment";
// import { GrAttachment } from "react-icons/gr";
// import colors from "core/resources/theme/colors";

export interface TimelineLog {
  title: string;
  subtitle?: string;
  message?: string | null;
  data: string;
  user?: {
    id: string;
    nome: string;
  };
  arquivos?: {
    id: string;
    nome: string;
    referencia: string;
    mimetype: string;
  }[];
}

interface TimelineLogsProps {
  data: TimelineLog;
}

function TimelineLogs({ data }: TimelineLogsProps) {
  return (
    <Container>
      <Flex flexDir={"column"} mb={"8px"}>
        <Flex justifyContent="space-between">
          <Flex>
            <Text
              fontSize="14px"
              color={"#8291A9"}
              fontWeight={"500"}
              fontStyle={"italic"}
              mr={"8px"}
            >
              {moment(data.data).format("DD/MM/YYYY HH:mm:ss")}
            </Text>

            <Tag size={"sm"}>{data.title}</Tag>
          </Flex>
          {/* <Flex align="center">
            <GrAttachment color={colors.blue}/>
          </Flex> */}
        </Flex>

        <Flex flexDir="column" gap="8px">
          {data.subtitle ? (
            <Text mt={2} fontSize={12} fontWeight="medium">
              {data.subtitle}
            </Text>
          ) : null}

          {data.user ? (
            <Flex mt={data.subtitle ? -1 : 2} fontSize={12}>
              Autor:{" "}
              <strong style={{ paddingLeft: 4 }}>{data.user.nome}</strong>
            </Flex>
          ) : null}

          {data.message ? (
            <Text mt={2} fontSize={12}>
              {data.message}
            </Text>
          ) : null}
        </Flex>
      </Flex>
    </Container>
  );
}

export default TimelineLogs;
